import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Redirect } from 'react-router'

import { ADD_CARD } from '../../../../services/data/registrationSteps.json'
import {
  setGACustomPageView,
  setGACustomEvent,
} from '../../../../services/analytics/google-analytics'

import Icon from '../../../../components/ui/Icon/Icon'
import { postDevices } from '../../../../services/api/requests/Device'
// import * as GCashApiService from '../../../../services/api/requests/GCash'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import downloadAppLink from '../../../../services/redirection/downloadAppLink'
// import GCashModal from '../../../../components/home/GCashModal/GCashModal'
import { doHandleSSORedirection } from '../../../../controllers/Registration'

// simplified imports
// import gcashIcon from '../../../../assets/img/simplified-login/gcash-white.png'
// import linkCardIcon from '../../../../assets/img/simplified-login/link-card-white.png'
import { Layout as MainLayout } from '../../../../components/ui/SimplifiedLogin'
import { ContentContainer } from '../../../simplified.login/components/MainView/MainView.style'
import {
  Title,
  Description,
  LinkOptionsLabel,
  LinkOption,
  ContinueLink,
  TopConfetti,
  DownloadOptionsContainer,
  // LinkOptionsContainer,
  // LinkOptionButton,
  // LinkOptionImg,
} from './MainView.style'
import { REGISTRATION_STEPS } from '../../../../services/hooks/useRegistrationBanners'

function MainView({
  step,
  push,
  browser,
  setDevice,
  primaryInfo,
  accessToken,
  location = {},
  saveAccessToken,
  redirectAfterAuth,
}) {
  // const [showGCAshModal, setShowGCashModal] = React.useState(false)
  // const [isGCashLinked, setIsGCashLinked] = React.useState(false)

  React.useEffect(() => {
    if (location)
      setGACustomPageView({
        page: location.pathname,
        title: 'Registration - Account Creation Success',
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  React.useEffect(() => {
    if (window.document.cookie.includes('web_uuid=')) {
      return
    }
    const { name, os, version } = browser
    postDevices({
      platform: 'web',
      deviceName: name,
      deviceModel: os,
      osVersion: version,
    }).then(res => {
      setDevice(res.data)
    })
  }, [browser, setDevice])

  const redirectToThirdParty = (redirectUri, code) => {
    if (typeof window !== undefined && window.location && redirectUri) {
      window.location.href = redirectUri + (code ? `?code=${code}` : '')
    }
  }

  const continueWithBrowser = React.useCallback(async () => {
    setGACustomEvent('button_cta', {
      screen_name: 'Registration - Account Creation Success',
      button_name: 'Continue with Browser',
    })
    await saveAccessToken(accessToken)
    //sso redirection
    await doHandleSSORedirection(
      location.search,
      redirectToThirdParty,
      accessToken,
      async () => {
        await push(redirectAfterAuth || '/')
      },
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [push, saveAccessToken, accessToken, redirectAfterAuth])

  // const toggleGCashModal = async () => {
  //   setShowGCashModal(!showGCAshModal)
  // }

  // const continueRegistration = React.useCallback(() => {
  //   // if (step === AVATAR) {
  //   //   push(`/register/avatar${location.search || ''}`)
  //   // }
  //   if (step === ADD_CARD) {
  //     push(`/register/add-card${location.search || ''}`)
  //   }
  // }, [step, push])

  // const onCloseGCashPopup = () => {
  //   setGACustomEvent('button_cta', {
  //     screen_name: 'Registration - GCash Popup',
  //     button_name: 'Not Now',
  //   })
  //   toggleGCashModal()
  // }

  // const linkGCash = async () => {
  //   try {
  //     await GCashApiService.linkGCash(accessToken)
  //     setIsGCashLinked(true)
  //   } catch (err) {}
  // }
  // const onLink = async () => {
  //   setGACustomEvent('button_cta', {
  //     screen_name: 'Registration - GCash Popup',
  //     button_name: 'Proceed',
  //   })
  //   linkGCash()
  //   toggleGCashModal()
  // }

  if (primaryInfo === null || step !== ADD_CARD) {
    return <Redirect to={`/register${location.search || ''}`} />
  }
  // if (location.state && location.state.registrationStep !== ADD_CARD) {
  //   return <Redirect to={`/register${location.search || ''}`} />
  // }

  return (
    <MainLayout
      registrationStep={REGISTRATION_STEPS.REGISTER_SUCCESS}
      noMobileLogo
    >
      <ContentContainer minHeight={400}>
        {/* <TopConfetti /> */}
        <div>
          <Title>Hooray!</Title>
          <Description>
            You’ve successfully created your Zing account. Download the app to
            explore your benefits.
          </Description>
        </div>
        {/*
        ST - 6741 -> 6810 - Remove the GCash linking in the registration flow
        <div>
          <LinkOptionsLabel>Link your</LinkOptionsLabel>
          <LinkOptionsContainer>


            <LinkOption>
              <LinkOptionButton
                small
                variant="primary"
                icon={<LinkOptionImg src={gcashIcon} />}
                onClick={!isGCashLinked && toggleGCashModal}
                disabled={isGCashLinked}
              >
                GCash Account
              </LinkOptionButton>
            </LinkOption>

             <LinkOption>
              <LinkOptionButton
                small
                variant="primary"
                icon={<LinkOptionImg src={linkCardIcon} />}
                onClick={continueRegistration}
              >
                Credit Cards
              </LinkOptionButton>
            </LinkOption>
          </LinkOptionsContainer>
          <GCashModal
            show={showGCAshModal}
            zIndex={10025}
            gCashData={{ status: 'No Pending Request' }}
            onLink={onLink}
            onClose={onCloseGCashPopup}
            mobileNumber={primaryInfo ? primaryInfo.mobileNumber : ''}
            onLoad={() =>
              setGACustomEvent('screen_view', {
                screen_name: 'Registration - GCash Popup',
              })
            }
            disableOverlayClick
            registration
          />
        </div> */}
        <div>
          <LinkOptionsLabel>
            Zing is better as an app. <span>Download now!</span>
          </LinkOptionsLabel>
          <DownloadOptionsContainer>
            <LinkOption>
              <ActionButton
                small
                variant="secondary"
                icon={<Icon name="appstore" />}
                onClick={downloadAppLink('iOS')}
              >
                App Store
              </ActionButton>
            </LinkOption>
            <LinkOption>
              <ActionButton
                small
                variant="secondary"
                icon={<Icon name="playstore" />}
                onClick={downloadAppLink('Android')}
              >
                Google Play
              </ActionButton>
            </LinkOption>
          </DownloadOptionsContainer>
        </div>
        <ContinueLink onClick={continueWithBrowser}>
          Or Continue using the browser
        </ContinueLink>
        <div />
      </ContentContainer>
    </MainLayout>
  )
}

MainView.defaultProps = {
  primaryInfo: null,
  step: ADD_CARD,
  location: {},
}

MainView.propTypes = {
  primaryInfo: PropTypes.shape(),
  step: PropTypes.number,
  push: PropTypes.func.isRequired,
  location: PropTypes.object,
}

export default MainView
